export const data = {
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/d2e8f20713c2-tool-icon-web-shop.jpg',
  },
  title: 'What was the message about?',
}
